import { useMutation, useQuery } from "@tanstack/react-query";
import { SearchDto } from "../../../assets/utils/lib/searchDto";
import { IActionResponse, IActionResult, QuestionnaireClient } from "../../../services/proxies";
import { LookupAnswerTypeDto } from "../../../services/dto";

export namespace AnswerTypeService {
  const questionnaireClient = new QuestionnaireClient();

    export const save = () =>
        useMutation<IActionResult<LookupAnswerTypeDto>, Error, LookupAnswerTypeDto>({
      mutationFn: async (payload: LookupAnswerTypeDto) => {
        return await questionnaireClient.saveLookupAnswerTypeAsync(payload);
      },
    });

    export const getAnswerTypeQuery = (questionId: string | undefined) =>
    useQuery({
      queryKey: ["answertypeQuery", questionId],
        queryFn: async () => await questionnaireClient.getLookupAnswerTypeAsync(questionId),
      enabled: Boolean(questionId),
    });

  export const gridQuery = (searchQuery: SearchDto) =>
    useQuery({
        queryKey: ["answertypeGridQuery", searchQuery],
      queryFn: async () =>
        await questionnaireClient.searchLookupAnswerTypesAsync(searchQuery),
    });

  export const deActivateQuestiontype = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (answerId: string | undefined) => {
        return await questionnaireClient.deleteLookupAnswerTypeAsync(answerId);
      },
    });

  export const getAnswerTypesQuery = () =>
    useQuery({
      queryKey: ["answertypesQuery"],
      queryFn: async () => await questionnaireClient.getLookupAnswerTypesAsync(),
    });
}
